import { render, staticRenderFns } from "./AddCategoryDialog.vue?vue&type=template&id=28e305cc&scoped=true&"
import script from "./AddCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./AddCategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoryDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddCategoryDialog.vue?vue&type=style&index=1&id=28e305cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e305cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VTextField})
